import script from "./VStub.vue?vue&type=script&lang=ts&setup=true"
export * from "./VStub.vue?vue&type=script&lang=ts&setup=true"

import "./VStub.vue?vue&type=style&index=0&id=135fe3fa&lang=sass"

const __exports__ = script;

export default __exports__